// extracted by mini-css-extract-plugin
export default {"title":"MobileSelection_title__llSgP","tips":"MobileSelection_tips__HFBlt"};